define('app/views/simple_slider',['app/setup'], function(takhfifan) {

  takhfifan.simpleSlider = Backbone.View.extend({

    events: {
      'click .sslider__next' : 'moveRight',
      'click .sslider__prev' : 'moveLeft'
    },

    initialize: function() {
      var _this = this;

      this.list = this.$el.find('.sslider__list');
      this.items = this.$el.find('.sslider__list > li');
      this.wrapper = this.$el.find('.sslider__wrapper');
      this.slideCount = this.items.length;
      // this.slideWidth = this.items.width();
      this.slideWidth = this.$el.parent().width();
      this.slideHeight = this.items.height();
      this.sliderUlWidth = this.slideCount * this.slideWidth;

      if(this.slideCount > 1){
        this.wrapper.css({ width: this.slideWidth, height: this.slideHeight || "auto" });
        this.list.css({ width: this.sliderUlWidth, marginRight: - this.slideWidth });
        this.items.css({ width: this.slideWidth});

        this.items.last().prependTo(this.list);

        $(window).resize(function () {
          var parentWidth = _this.$el.parent().width();
          _this.wrapper.css('width', parentWidth);
          _this.items.css({width: parentWidth});
          _this.list.css({ width: parentWidth * _this.slideCount, marginRight: - parentWidth });
          _this.sliderUlWidth = _this.slideCount * parentWidth;
          _this.wrapper.css('height', _this.items.height());
        })

      }else{
        this.$el.find('.sslider__next').hide();
        this.$el.find('.sslider__prev').hide();
      }

      this.$el.removeClass('sslider--init');
    },

    moveLeft: function(e) {
      e.preventDefault();
      var _this = this;
      this.list.fadeOut( "slow", function() {
        _this.$el.find('.sslider__list > li:last-child').prependTo(_this.list);
        _this.list.fadeIn();
      });
      /*this.list.animate({
        right: + _this.slideWidth
      }, 200, function () {
        _this.$el.find('.sslider__list > li:last-child').prependTo(_this.list);
        _this.list.css('right', '');
      });*/
    },

    moveRight: function(e) {
      e.preventDefault();
      var _this = this;
      this.list.fadeOut( "slow", function() {
        _this.$el.find('.sslider__list > li:first-child').appendTo(_this.list);
        _this.list.fadeIn();
      });
      /*this.list.animate({
        right: - _this.slideWidth
      }, 200, function () {
        _this.$el.find('.sslider__list > li:first-child').appendTo(_this.list);
        _this.list.css('right', '');
      });*/
    }

  });
});

